import { FC } from 'react'
import styled from 'styled-components'
import { Accordion, Box, Button, Text } from '@mrshmllw/smores-react'

import { ExclusionState } from './exclusion.type'
import { SimpleHeader } from 'components/Header/SimpleHeader'
import { PageWrapper } from 'components/PageWrapper'
import ConfusedLogo from 'assets/images/confused-logo-black.svg?react'
import ErrorMarshform from 'assets/images/marshforms/error.svg?react'

import { VehicleType } from 'types'
import { useTracking } from 'utils'

export const WebExclusion: FC<ExclusionState> = ({
  exclusionCode,
  quoteId,
  vehicleType,
  firstQuoteId,
}) => {
  const track = useTracking('Web Exclusion', { firstQuoteId, quoteId, exclusionCode })

  const handleClick = () => {
    track('Clicked Get a quote on Confused.com')
    window.location.href =
      vehicleType === VehicleType.CAR
        ? 'https://www.confused.com/campaign/affiliates/car-insurance?MediaCode=2503&utm_medium=affiliate&utm_source=marshmallow&utm_campaign=affiliates_marshmallow_motor&utm_content=wastelead&utm_term=wastelead'
        : 'https://www.confused.com/campaign/affiliates/van-insurance?MediaCode=2503&utm_medium=affiliate&utm_source=marshmallow&utm_campaign=affiliates_marshmallow_van&utm_content=wastelead&utm_term=wastelead'
  }

  return (
    <>
      <SimpleHeader />
      <PageWrapper maxWidth="630px" mobile="0" pl="0" pr="0">
        <LogoWrapper maxWidth="112px">
          <ConfusedLogo />
        </LogoWrapper>
        <Box mb="12px" flex justifyContent="center">
          <ErrorMarshform />
        </Box>
      </PageWrapper>
      <PageWrapper maxWidth="630px" pl="0" pr="0">
        <Text tag="h2" typo="hero-alternate" mb="8px" align="center">
          Sorry, we can’t cover you. But don’t worry!
        </Text>
        <Text mb="24px" align="center">
          We’d love to insure everyone, but as you can see it’s not always possible. Confused.com
          will show all their options available to you, in order of price.{' '}
        </Text>
        <Accordion title="Why can’t you insure me?" fullBorder mb="12px">
          <Text mb="12px">There could be a few reasons why we can’t insure you. For example:</Text>
          <ul>
            <li>&#8226; We may not be able to insure your particular car</li>
            <li>
              &#8226; We may not be able to insure the drivers (they could be too young or too old)
            </li>
            <li>
              &#8226; We may not offer the type of insurance you need (e.g. commercial insurance){' '}
            </li>
          </ul>
        </Accordion>

        <Accordion title="Should I try again with Marshmallow?" fullBorder>
          <Text mb="12px">
            Not yet. Based on the information you’ve given us, we won’t be able to insure you.
            Confused.com will show you all the options available, so you can get the cover you need.{' '}
          </Text>
          <Text>We’re always working on new things, so do check back on us in the future! </Text>
        </Accordion>
        <Button primary onClick={handleClick} mt={{ custom: 20 }}>
          Get a quote on Confused.com
        </Button>
      </PageWrapper>
    </>
  )
}

const LogoWrapper = styled(Box)`
  position: absolute;
  left: 16px;

  @media (min-width: 768px) {
    left: 0;
  }
`
